/**
 * Fonte única da normalização de `mes_referencia`.
 *
 * A coluna é texto livre e a tela de Cobranças filtra por igualdade exata
 * (`selectedMeses.includes(fatura.mes_referencia)`). Qualquer coisa fora do
 * formato canônico some do filtro — foi o que aconteceu com "ABRILÁJULHO2026",
 * "032026 Á 072026" e "0127", digitados à mão no modal de cobrança avulsa: a
 * fatura existia, mas a operadora não achava e recriava, deixando linhas órfãs
 * "Em aberto" que inflavam Vencido/A Receber.
 *
 * Estava definida em views/Financeiro/FinanceiroLayout.tsx e copiada em
 * views/PortalConsumidor/format.ts. Vive aqui porque `src/lib` é compartilhado e
 * leve — importar do FinanceiroLayout arrastaria o módulo inteiro (2 mil linhas)
 * para quem só precisa formatar um mês.
 *
 * Devolve a entrada intacta quando não reconhece o formato: normalizar não pode
 * inventar mês.
 */

export const MESES_ABREV = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

export const normalizeMesReferencia = (m: any): string => {
  if (!m) return '';
  const mStr = String(m).trim().toUpperCase().replace(/\./g, '').replace(/\s/g, '');
  m = mStr;

  let mes = '';
  let ano = '';

  if (m.includes('/')) {
    const parts = m.split('/');
    if (parts.length === 2) {
      [mes, ano] = parts;
    }
  } else if (/^\d{5,6}$/.test(m)) {
    if (m.length === 6) {
      mes = m.substring(0, 2);
      ano = m.substring(2);
    } else {
      mes = m.substring(0, 1);
      ano = m.substring(1);
    }
  } else {
    const match = m.match(/^([A-Z]+|\d+)(\d{2,4})$/);
    if (match) {
      [, mes, ano] = match;
    } else {
      return m;
    }
  }

  if (!mes || !ano) return m;

  if (/^\d{1,2}$/.test(mes)) {
    const mesIndex = parseInt(mes, 10) - 1;
    if (mesIndex >= 0 && mesIndex < 12) {
      mes = MESES_ABREV[mesIndex];
    }
  } else {
    const foundIndex = MESES_ABREV.findIndex(mName => mes.startsWith(mName));
    if (foundIndex !== -1) {
      mes = MESES_ABREV[foundIndex];
    }
  }

  if (ano.length === 2) {
    ano = `20${ano}`;
  }

  if (ano.length !== 4 || !MESES_ABREV.includes(mes)) {
    return m;
  }

  return `${mes}/${ano}`;
};

/**
 * True quando a normalização reconheceu o valor e produziu o formato canônico
 * 'JAN/2026'. Use para avisar quem digita antes de gravar texto livre.
 */
export const isMesReferenciaCanonico = (m: any): boolean =>
  /^[A-Z]{3}\/\d{4}$/.test(normalizeMesReferencia(m));
